import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {LoginComponent} from "./components/login/login.component";
import {AuthGuardService as AuthGuard} from "./services/auth/auth-guard.service";
import {ProfileComponent} from "./components/profile/profile.component";
import {WhatsNewComponent} from "./components/whats-new/whats-new.component";
import {ProjectsComponent} from "./components/projects/projects.component";
import {ProjectSettings} from "./components/projects/components/projectSettings/project-settings.component";
import {TasksComponent} from "./components/tasks/tasks.component";
import {UserResolver} from "./resolver/user.resolver";
import {ProjectResolver} from "./resolver/project.resolver";
import {UnsavedChangesGuard} from "./guards/unsaved-changes.guard";
import {CheckoutComponent} from "./components/shop/checkout.component";
import {IfcViewerComponent} from "./components/util/ifc-viewer/ifc-viewer.component";
import {ReportsComponent} from "./components/reports/reports.component";
import {FilesComponent} from "./components/files/files.component";
import {FileViewerComponent} from "./components/util/file-viewer/file-viewer.component";
import {ChatBICComponent} from "./components/chatBIC/chatBIC.component";
import {WorkflowEditorComponent} from "./components/workflow-editor/workflow-editor.component";
import {KiEditorComponent} from "./components/ruleManagement/ki-editor/ki-editor.component";
import {HybridEditorComponent} from "./components/ruleManagement/hybrid-editor/hybrid-editor.component";
import {
  IdsRuleManagementEditorComponent
} from "./components/ruleManagement/ids-editor/ids-rule-management-editor.component";

import {featureFlagGuard} from "./services/featureFlags/feature-flag-guard.service";
import {catalogSubmissionGuard, rulesetAdminGuard} from "./services/auth/ruleset-admin-guard.service";
import {
  QualityChooseFilesComponent
} from "./components/checks/qualityCheck/quality-choose-files/quality-choose-files.component";
import {
  QualityChooseRulesComponent
} from "./components/checks/qualityCheck/quality-choose-rules/quality-choose-rules.component";
import {QualityCheckResolver} from "./resolver/quality-check-resolver.service";
import {QualityReportComponent} from "./components/checks/qualityCheck/quality-report/quality-report.component";
import {
  QualityComplianceReport
} from "./components/checks/qualityCheck/quality-compliance-report/quality-compliance-report.component";
import {
  BimBaseCheckReportComponent
} from "./components/checks/bimCheck/components/bim-base-check-report/bim-base-check-report.component";

import {OrganisationsComponent} from "./components/organisations/organisations.component";
import {OrganisationResolver} from "./resolver/organisation.resolver";
import {
  OrganisationSettingsComponent
} from "./components/organisations/components/organisation-settings/organisation-settings.component";
import {
  OrganisationCreateComponent
} from "./components/organisations/components/organisation-create/organisation-create.component";
import {BimIdComponent} from "./components/special/bim-id/bim-id.component";
import {AllInCheckComponent} from "./components/checks/all-in-check/all-in-check.component";
import {
  LoiCheckReportComponent
} from "./components/checks/bimCheck/components/loi-check-report/loi-check-report.component";
import {QualityLoadingComponent} from "./components/checks/qualityCheck/quality-loading/quality-loading.component";
import {HoaiCheckReport} from "./components/checks/hoaiCheck/hoai-check-report/hoai-check-report.component";
import {Routes} from '@angular/router';
import {
  IdsCheckReportComponent
} from "./components/checks/bimCheck/components/ids/ids-check-report/ids-check-report.component";
import {MyCheckHubComponent} from "./components/my-checks/my-check-hub/my-check-hub.component";
import {MyChecksExecutionComponent} from "./components/my-checks/my-checks-execution/my-checks-execution.component";
import {MyChecksBuilderComponent} from "./components/my-checks/my-checks-builder/my-checks-builder.component";
import {CheckReportPageComponent} from "./components/reports/check-report-page/check-report-page.component";


export const routes: Routes = [
  {path: '', redirectTo: 'organisations', pathMatch: 'full'},
  {
    path: 'projects',
    canActivate: [AuthGuard],
    data: {title: 'Projekte'},
    children: [
      {path: '', component: ProjectsComponent, data: {title: null}, pathMatch: 'full'},
      {
        path: 'create',
        resolve: {user: UserResolver},
        component: ProjectSettings,
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {title: 'Neues Projekt'},
      },
      {
        path: ':id',
        canActivate: [AuthGuard],
        resolve: {user: UserResolver, project: ProjectResolver},
        children: [
          {path: '', redirectTo: 'dashboard', pathMatch: 'prefix'},
          {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {title: 'Dashboard'}},
          {
            path: 'bim-id',
            canActivate: [AuthGuard, featureFlagGuard('bim-id', '')],
            component: BimIdComponent,
            children: [
              {
                path: '',
                loadChildren: () => import('@buildinginformationcloud/bim-id').then(m => m.BimIdModule)
              }
            ]
          },
          {
            path: 'files',
            canActivate: [AuthGuard],
            children: [
              {
                path: '',
                component: FilesComponent,
                data: {title: 'Dateien', titleParam: null},
              },
              {
                path: 'document-classes',
                loadComponent: () =>
                  import('./components/files/components/document-classes/document-classes.component')
                    .then(m => m.DocumentClassManagementComponent),
                data: {title: 'Dokumentenklassen', titleParam: null},
              },
              {
                path: ':id',
                component: FileViewerComponent,
                data: {title: 'Dateien', titleParam: null},
              },
            ]
          },
          {
            path: 'tasks',
            component: TasksComponent,
            data: {title: "Tasks"},
            children: [
              {
                path: ':id',
                component: TasksComponent,
                canActivate: [AuthGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: {title: null},
              },
            ]
          },
          {
            path: 'ifc-viewer',
            canActivate: [AuthGuard],
            runGuardsAndResolvers: 'always',
            data: {title: "IFC-Viewer"},
            component: IfcViewerComponent,
          },
          {
            path: 'quality',
            children: [
              {path: '', redirectTo: "rules", pathMatch: 'full'},
              {path: 'choose-files', component: QualityChooseFilesComponent, data: {title: "Qualitäts-Check Dateien"}},
              {
                path: 'rules',
                component: QualityChooseRulesComponent,
                data: {title: "Qualitäts-Check Prüfregeln"}
              },
              {
                path: ':checkId', resolve: {
                  qualityCheck: QualityCheckResolver,
                },
                runGuardsAndResolvers: 'always',
                children: [
                  {
                    path: 'loading',
                    component: QualityLoadingComponent,
                    data: {title: "Qualitäts-Check Laden"},
                  },
                  {
                    path: 'report', data: {title: "Qualitäts-Check Ergebnis"}, children: [
                      {path: '', component: QualityReportComponent},
                      {path: 'compliance', component: QualityComplianceReport},
                    ]
                  }
                ]
              },
            ],
          },
          {
            path: 'all-in-check',
            children: [
              {
                path: '',
                component: AllInCheckComponent,
                data: {title: "All-In Check"}
              },
              {
                // HOAI und LOIplus laufen als myCheck-Prüflauf: die Kacheln navigieren hierher
                // (jeweils mit ?definitionId=… des global bereitgestellten Prüflaufs).
                path: 'execute',
                component: MyChecksExecutionComponent,
                data: {title: "Prüfung ausführen"}
              },
              // Die alten Schritte (Regelauswahl/Dateiauswahl/Loading/Regeleditoren) sind entfallen.
              // Die Berichtsrouten bleiben: bestehende HOAI- und LOIplus-Prüfungen werden aus der
              // Ergebnisliste weiter über sie geöffnet (CheckReportService.resolveCheckRoute).
              {
                path: 'hoai',
                data: {title: "HOAI-Check"},
                children: [
                  {
                    path: ':checkId',
                    children: [
                      {path: '', redirectTo: 'details', pathMatch: 'full'},
                      {
                        path: 'details',
                        children: [
                          {path: '', component: HoaiCheckReport},
                        ]
                      },
                    ]
                  },
                ]
              },
              {
                path: 'bim-check',
                children: [
                  {
                    path: ':reportId',
                    children: [
                      {
                        path: '',
                        redirectTo: 'base-check',
                        pathMatch: 'full'
                      },
                      {
                        path: 'base-check',
                        component: BimBaseCheckReportComponent,
                        data: {title: "BIM-Basis-Check"},
                      },
                      {
                        path: 'loi-check',
                        component: LoiCheckReportComponent,
                        data: {title: "LOI-Check"},
                      },
                      {
                        path: 'ids-check',
                        component: IdsCheckReportComponent,
                        data: {title: "IDS-Check"},
                      }
                    ]
                  },
                ]
              },
            ]
          },
          {
            path: 'reports',
            component: ReportsComponent,
            data: {
              title: "Berichte",
              titleParam: null
            }
          },
          {
            path: 'reports/:checkResultId',
            component: CheckReportPageComponent,
            data: {title: "Prüfbericht"}
          },
          {
            path: 'settings',
            component: ProjectSettings,
            canDeactivate: [UnsavedChangesGuard],
            data: {title: "Projektdaten", titleParam: null},
          },
          {
            path: 'chat',
            canActivate: [AuthGuard],
            runGuardsAndResolvers: 'always',
            resolve: {
              project: ProjectResolver,
              user: UserResolver,
            },
            data: {title: "Chat"},
            children: [
              {path: '', component: ChatBICComponent, pathMatch: 'full'},
              {path: ':chatId', component: ChatBICComponent},
              {path: '**', redirectTo: ''}
            ]
          },
          {
            path: 'my-checks',
            canActivate: [AuthGuard],
            children: [
              {
                // Ein Bereich, drei Tabs; der aktive steht im Query-Parameter `tab`.
                path: '',
                component: MyCheckHubComponent,
                data: {title: 'myCheck'}
              },
              {
                path: ':rulesetId/ki',
                component: KiEditorComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {title: 'KI-myCheck bearbeiten'}
              },
              {
                path: ':rulesetId/hybrid',
                component: HybridEditorComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {title: 'Hybriden myCheck bearbeiten'}
              },
              {
                path: ':rulesetId/hybrid/:ruleId',
                component: WorkflowEditorComponent,
                data: {title: 'Hybride Prüfregel bearbeiten'}
              },
              {
                path: ':rulesetId/ids',
                component: IdsRuleManagementEditorComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {title: 'IDS-myCheck bearbeiten'}
              }
            ]
          },
          {
            path: 'check-runs',
            canActivate: [AuthGuard],
            children: [
              {
                // Kein Redirect: verschickte Links auf `check-runs` landen direkt bei den Prüfläufen.
                path: '',
                component: MyCheckHubComponent,
                data: {title: 'myCheck', defaultTab: 'runs'}
              },
              {
                path: 'builder/:definitionId',
                component: MyChecksBuilderComponent,
                data: {title: 'Prüflauf konfigurieren'}
              },
              {
                path: 'execute',
                component: MyChecksExecutionComponent,
                data: {title: 'Prüfung ausführen'}
              },
              {
                path: 'log',
                component: MyChecksExecutionComponent,
                data: {title: 'Prüfungslog'}
              }
            ]
          },
          {
            // Begriffstausch (Prüfregelset → myCheck, myCheck → Prüflauf): der frühere Pfad
            // `rule-management` ist jetzt `my-checks`. pathMatch 'prefix' deckt auch die
            // Editor-Kindpfade (`:rulesetId/ki` usw.) und deren Query-Parameter mit ab, sodass
            // gesetzte Lesezeichen und verschickte Links weiter funktionieren.
            //
            // MUSS hinter den echten Zweigen stehen: der Router nimmt die erste passende Route.
            path: 'rule-management',
            redirectTo: 'my-checks',
            pathMatch: 'prefix',
          },
          {
            path: 'workflows',
            canActivate: [AuthGuard],
            children: [
              {
                path: '',
                component: MyCheckHubComponent,
                data: {title: 'myCheck', defaultTab: 'runs'}
              },
              {
                path: ':definitionId',
                component: WorkflowEditorComponent,
                data: {title: 'Flow Editor'}
              }
            ]
          }
        ]
      },
      {path: '**', redirectTo: 'dashboard'}
    ]
  },
  {
    path: 'tasks',
    component: TasksComponent,
    data: {title: "Tasks"}
  },
  {
    path: 'reports',
    children: [
      {
        path: '',
        component: ReportsComponent,
        data: {
          title: "Berichte",
          titleParam: null
        },
      },
      {
        path: 'ifc/:reportId',
        component: LoiCheckReportComponent,
        data: {
          title: "IFC-Check",
          titleParam: null,
        }
      }
    ]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {title: "Account"},
    resolve: {
      user: UserResolver,
    },
  },
  {
    path: 'whats-new',
    component: WhatsNewComponent,
    canActivate: [AuthGuard],
    data: {title: "Versionsverlauf"},
  },
  {
    path: 'organisations',
    canActivate: [AuthGuard],
    data: {title: "Unternehmen"},
    children: [
      {path: '', component: OrganisationsComponent, data: {title: null}, pathMatch: 'full'},
      {
        path: 'create',
        resolve: {
          user: UserResolver,
        },
        component: OrganisationCreateComponent,
        canActivate: [AuthGuard],
        data: {title: "Neue Organisation"}
      },
      {
        path: ':id',
        canActivate: [AuthGuard],
        resolve: {
          user: UserResolver,
          organisation: OrganisationResolver,
        },
        children: [
          {
            path: 'settings',
            component: OrganisationSettingsComponent,
            canDeactivate: [UnsavedChangesGuard],
            data: {title: "Organisationsdaten", titleParam: null},
          },
        ]
      }
    ]
  },
  {
    path: 'register',
    component: LoginComponent,
    data: {logout: false, resetPassword: false, newVerification: false, isProfile: false, register: true},
  },
  {
    path: 'verify',
    component: LoginComponent,
    data: {verify: true, isPassword: false}
  },
  {
    path: 'verifyNewPassword',
    component: LoginComponent,
    data: {verify: true, isPassword: true}
  },
  {
    path: 'resetPassword',
    component: LoginComponent,
    data: {logout: false, resetPassword: true, newVerification: false, isProfile: false}
  },
  {
    path: 'newVerificationPassword',
    component: LoginComponent,
    data: {logout: false, resetPassword: true, newVerification: true, isProfile: false}
  },
  {
    path: 'newVerificationProfile',
    component: LoginComponent,
    data: {logout: false, resetPassword: true, newVerification: true, isProfile: true}
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {logout: false, resetPassword: false, newVerification: false, isProfile: false}
  },
  {
    path: 'mfa',
    component: LoginComponent,
    data: {logout: false, resetPassword: false, newVerification: false, isProfile: false, isMfa: true}
  },
  {
    // Kein AuthGuard: an dieser Stelle gibt es noch kein Access-Token, nur das
    // Reaktivierungs-Token aus dem Navigations-State. Fehlt das, schickt die Komponente
    // zurueck zum Login.
    path: 'reactivateAccount',
    component: LoginComponent,
    data: {logout: false, resetPassword: false, newVerification: false, isProfile: false, isReactivate: true}
  },
  {
    path: 'checkout',
    data: {title: "Abo Verwaltung"},
    component: CheckoutComponent
  },
  {
    path: 'logout',
    component: LoginComponent,
    data: {logout: true, resetPassword: false, newVerification: false, isProfile: false}
  },
  {
    path: 'tasks',
    component: TasksComponent,
    canActivate: [AuthGuard],
    data: {title: "Tasks"},
    children: [
      {
        path: 'list',
        component: TasksComponent,
        canActivate: [AuthGuard],
        data: {title: null, tab: 0}
      },
      {
        path: 'board',
        component: TasksComponent,
        canActivate: [AuthGuard],
        data: {title: null, tab: 1}
      },
      {
        path: ':id',
        component: TasksComponent,
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {title: null},
      },
      {
        path: 'create',
        component: TasksComponent,
        canActivate: [AuthGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: {title: null}
      },
      {path: '**', redirectTo: 'list'}
    ]
  },
  {
    // Admin-Bereich für plattform-globale Regelwerke. Top-level (projektunabhängig),
    // nur mit GLOBAL_CHECKRULE_ADMIN. Bearbeitung nutzt die bestehenden Editoren im Edit-Modus.
    path: 'admin/my-checks',
    canActivate: [AuthGuard, rulesetAdminGuard()],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/admin-rulesets/admin-rulesets-overview.component')
            .then(m => m.AdminRulesetsOverviewComponent),
        data: {title: 'myChecks'}
      },
      {
        path: ':rulesetId/ki',
        canActivate: [catalogSubmissionGuard()],
        component: KiEditorComponent,
        canDeactivate: [UnsavedChangesGuard],
        data: {title: 'myCheck bearbeiten', adminGlobal: true},
      },
      {
        path: ':rulesetId/hybrid',
        canActivate: [catalogSubmissionGuard()],
        component: HybridEditorComponent,
        canDeactivate: [UnsavedChangesGuard],
        data: {title: 'myCheck bearbeiten', adminGlobal: true}
      },
      {
        path: ':rulesetId/hybrid/:ruleId',
        canActivate: [catalogSubmissionGuard()],
        component: WorkflowEditorComponent,
        data: {title: 'Regel bearbeiten', adminGlobal: true}
      },
      {
        path: ':rulesetId/ids',
        canActivate: [catalogSubmissionGuard()],
        component: IdsRuleManagementEditorComponent,
        canDeactivate: [UnsavedChangesGuard],
        data: {title: 'myCheck bearbeiten', adminGlobal: true}
      },
    ]
  },
  {
    // Admin-Bereich für zentral bereitgestellte myChecks. Top-level (projektunabhängig), damit der
    // ProjectResolver nicht greift; nur mit GLOBAL_CHECKRULE_ADMIN.
    //
    // Bearbeitet wird die beim Bereitstellen entstandene KOPIE – sie gehört dem Adminbereich und ist
    // vom Original im Kundenprojekt entkoppelt. Dafür läuft der normale myCheck-Builder im
    // adminGlobal-Modus (wie die Regelwerk-Editoren unter admin/rulesets).
    path: 'admin/check-runs',
    canActivate: [AuthGuard, rulesetAdminGuard()],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/admin-my-checks/admin-my-checks-overview.component')
            .then(m => m.AdminMyChecksOverviewComponent),
        data: {title: 'Zentral bereitgestellte Prüfläufe'}
      },
      {
        path: ':shareId/builder',
        component: MyChecksBuilderComponent,
        data: {title: 'Bereitgestellten Prüflauf bearbeiten', adminGlobal: true}
      },
    ]
  },
  {
    // Begriffstausch im Adminbereich: `admin/rulesets` (globale Regelwerke) heisst jetzt
    // `admin/my-checks`, der frühere `admin/my-checks` (bereitgestellte myChecks) `admin/check-runs`.
    // Nur der erste Pfad braucht eine Umleitung – der zweite ist kein Altbestand, sondern wurde
    // durch den neuen my-checks-Zweig ersetzt und würde sonst still auf den falschen Bereich zeigen.
    path: 'admin/rulesets',
    redirectTo: 'admin/my-checks',
    pathMatch: 'prefix',
  },
  {path: '**', redirectTo: ''}
];
